module.controller('sampleHomeFilterCtrl', [ '$scope', '$rootScope', '$state', '$compile', 'planSamplingService', 'dateUtilService', sampleHomeFilterCtrlFn ]);

function sampleHomeFilterCtrlFn($scope, $rootScope, $state, $compile, planSamplingService, dateUtil) {

	var vm = $scope;
	var vmParent = $scope.$parent;

	vm.isCollapsed = false;
	vm.planSiteSelected = 0;
	// se define en el scope padre
	// vm.SampleStateValues = SAMPLE_STATE.valuesReceive();

	/*
	 * Opciones del datepicker
	 */
	vm.optsDatepicker = {
		locale : {
			applyClass : 'btn-green',
			applyLabel : "Elegir",
			fromLabel : "desde",
			format : "YYYY-MM-DD",
			toLabel : "a",
			cancelLabel : 'Cancelar',
			customRangeLabel : 'Personalizado'
		},
		ranges : {
			'Sin fecha' : [ '', '' ],
			'Últimos 7 dias' : [ moment().subtract(6, 'days'), moment() ],
			'Últimos 30 dias' : [ moment().subtract(29, 'days'), moment() ],
			'Este mes' : [ moment().startOf('month'), moment().endOf('month') ],
			'Próximos 7 dias' : [ moment(), moment().add(6, 'days') ],
			'Próximos 30 dias' : [ moment(), moment().add(29, 'days') ],
		},
		autoApply : true,
		eventHandlers : {
			'apply.daterangepicker' : onApplyDatePicker
		},
		dateLimit : {
			month : 2
		}
	};

	/*
	 * valores de los filtros
	 */
	vm.filters = {
		client : {},
		idSample : {},
		states : [],
		datePicker : {},
		professionalSampling : {},
		planSampling: {},
		site: {},
		area: {}
	}
	/*
	 * Stado inciarl tomado de la url
	 */
	vm.stateIni = null;
	/*
	 * solo se muestran los clientes activos
	 */
	vm.clientCustomFilter = {
		active : true
	}

	vm.onClientChange = function(client) {
		if (vm.filters.client.selected.length <= 0) {
			vm.filters.site = {};
			vm.filters.area = {};
			vm.filters.planSampling = {};
		}
		vm.pagination.current = 1;
		realoadFilters();
		// loadSamples();
	}

	vm.onIdSampleChange = function(idSample) {
		vm.pagination.current = 1;
		realoadFilters()
		// loadSamples();
	}

	vm.onStateChange = function(state) {
		vm.pagination.current = 1;
		realoadFilters();
		// loadSamples();
	}

	vm.onPageChange = function(page) {
		vm.pagination.current = page;
		realoadFilters();
	}

	vm.onUserChange = function() {
		vm.pagination.current = 1;
		realoadFilters();
	}

	/*
	 * Cambia el plan de muestreo
	 */
	vm.onPlanChange = function(planSamplingSelected) {
		vm.pagination.current = 1;
		realoadFilters();
	}
	
	/**
	 * si el sitio cambia y esta vacio, se borra el área
	 */
	vm.onSiteChange = function(site) {
		if (vm.filters.site.selected.length <= 0)
			vm.filters.area = {};
		vm.pagination.current = 1;
		realoadFilters();
	}
	/*
	 * Cambia el valor selecionado del área
	 */
	vm.onAreaChange = function(area) {
		// vm.search();
		vm.pagination.current = 1;
		realoadFilters();
	}
	
	/*
	 * Si se cambia de selector entre sitio y plan de muestrep
	 */
	vm.sitePlanSelectClick = function(id) {

		var aSearch = true;
		// si no hay algo en los campos de siitio o plan de muestro no actualice
		// la busqueda
		if (!((vm.filters.site.selected && vm.filters.site.selected.length > 0) || (vm.filters.planSampling.selected && vm.filters.planSampling.selected.length > 0))) {
			aSearch = false;
		}

		vm.planSiteSelected = id;
		var io = $(".btn.btn-default.dropdown-toggle site-icon");
		if (io.length === 0) {
			io = $(".btn.btn-default.dropdown-toggle plan-sampling-icon");
		}
		var e;
		if (id === 0) {// sitio
			e = $compile("<site-icon></site-icon>")($scope);
			vm.filters.planSampling = {};
		} else {
			e = $compile("<plan-sampling-icon></plan-sampling-icon>")($scope);
			vm.filters.site = {};
			vm.filters.area = {};
		}
		io.replaceWith(e);

		if (aSearch)
			realoadFilters();
		// vm.search();
	}
	
	/**
	 * Eventos Datepicker
	 */
	function onApplyDatePicker(ev, picker) {
		vm.pagination.current = 1;
		realoadFilters();
	}

	/*
	 * refresca los query parameters de la url
	 */
	function realoadFilters() {
		var obj = {
			idClient : '',
			states : [],
			sampleId : '',
			start : '',
			end : '',
			userid : '',
			site : '',
			area : '',
			idplan : ''
		};
		// cliente
		if (vm.filters.client.selected && vm.filters.client.selected.length > 0) {
			obj.idClient = vm.filters.client.selected[0].id;
		}
		// estados
		if (vm.filters.states.selected && vm.filters.states.selected.length > 0) {
			obj.states = [];
			for ( var i in vm.filters.states.selected) {
				obj.states.push(vm.filters.states.selected[i].enumName);
			}
		}
		// muestra
		if (vm.filters.idSample.selected && vm.filters.idSample.selected.length > 0) {
			obj.sampleId = vm.filters.idSample.selected[0];
		}
		// paginacion
		if (vm.pagination.current) {
			obj.page = vm.pagination.current;
		}
		// fecha de toma de muestra
		if (!isEmpty(vm.filters.datePicker)) {
			if (vm.filters.datePicker.startDate.isValid() && vm.filters.datePicker.endDate.isValid()) {
				obj.start = dateUtil.date2String(vm.filters.datePicker.startDate);
				obj.end = dateUtil.date2String(vm.filters.datePicker.endDate.toDate());
			}
		}
		// usuario
		if (!isEmpty(vm.filters.professionalSampling.selected)) {
			obj.userid = vm.filters.professionalSampling.selected.id;
		}
		// site
		if (vm.filters.site.selected && vm.filters.site.selected.length > 0) {
			obj.site = vm.filters.site.selected[0].id;
		}
		// plan
		if (vm.filters.planSampling.selected && vm.filters.planSampling.selected.length > 0) {
			obj.idplan = vm.filters.planSampling.selected[0].id;
		}
		// area
		if (vm.filters.area.selected && vm.filters.area.selected.length > 0) {
			obj.area = vm.filters.area.selected[0].id;
		}
		
		
		$state.go(vmParent.urlSampleDetail, obj, {
			reload : vmParent.urlSampleDetail,
			notify : false,
		});
	}

	$scope.$on('$locationChangeSuccess', function(ev) {
		$scope.loadSamples();
	});

	function init() {
		// id de la muestra
		if ($state.params.sampleId) {
			vm.filters.idSample.selected = [$state.params.sampleId];
			vm.isCollapsed = true;
		}
		// cliente
		if ($state.params.idClient) {
			vm.filters.client.id = $state.params.idClient;
			vm.isCollapsed = true;
		}
		// estados
		if ($state.params.states) {
			if (angular.isArray($state.params.states)) {
				vm.stateIni = $state.params.states.map(function(s) {
					return getConstantById(SAMPLE_STATE, s);
				});
			} else {
				vm.stateIni = [];
				vm.stateIni.push(getConstantById(SAMPLE_STATE, $state.params.states));
			}
			vm.filters.states.selected = vm.stateIni;
			vm.isCollapsed = true;
		}
		// paginacion
		if ($state.params.page) {
			vm.pagination.current = $state.params.page;
		}
		// fecha de toma de muestra
		if ($state.params.start && $state.params.end) {
			vm.filters.datePicker.startDate = dateUtil.formatMomentDate($state.params.start);
			vm.filters.datePicker.endDate = dateUtil.formatMomentDate($state.params.end);
			vm.isCollapsed = true;
		}
		// usuario
		if ($state.params.userid) {
			vm.filters.professionalSampling.id = $state.params.userid;
			vm.isCollapsed = true;
		}
		// sitio
		if ($state.params.site) {
			vm.filters.site.id = $state.params.site;
			vm.isCollapsed = true;
		}
		// area
		if ($state.params.area) {
			vm.filters.area.id = $state.params.area;
			vm.isCollapsed = true;
		}
		// plan
		if ($state.params.idplan) {
			vm.filters.planSampling.id = $state.params.idplan;
			vm.sitePlanSelectClick(1);
			vm.isCollapsed = true;
		}

		$scope.loadSamples();

		$("#iconHelpState").qtip({
			content : {
				text : $("#helpState"),
				title : {
					text : "Código de colores de estados",
					button : true
				}
			},
			position : {
				my : 'left center',
				at : 'right center',
				adjust : {
					scroll : false,
					mouse : false
				}
			},
			show : {
				event : 'click',
				solo : true
			},
			hide : {
				event : 'unfocus'
			},
			style : {
				classes : 'qtip-bootstrap qtip-shadow qtip-rounded',
				width : "500px"
			}
		});

		// var def = securityService.getDeferred();
		//
		// if (def.promise.$$state.status == 0) {// pendiente
		// def.promise.then(function() {
		// idUser = securityService.getUser().idUser;
		// loadSamples();
		// });
		// } else {
		// idUser = securityService.getUser().idUser;
		// loadSamples();
		// }
	}

	$scope.getfilters = function() {
		var filter = {};

		var page = vm.pagination.current;
		// page = page == undefined ? 1 : page;
		// vm.pagination.current = page;

		var ps = $rootScope.pageSize;
		filter.offset = (page - 1) * ps;
		filter.limit = ps;

		// fecha de toma de muestra
		if (!isEmpty(vm.filters.datePicker)) {
			if (vm.filters.datePicker.startDate.isValid() && vm.filters.datePicker.endDate.isValid()) {
				vm.filters.datePicker.startDate.startOf('day');
				vm.filters.datePicker.endDate.endOf('day');
				filter.betweenTakenDate = [ dateUtil.datetime2String(vm.filters.datePicker.startDate), dateUtil.datetime2String(vm.filters.datePicker.endDate) ];
			}
		}
		// cliente
		if (vm.filters.client.selected && vm.filters.client.selected.length > 0) {
			filter.client = vm.filters.client.selected[0].id;
		} else if (vm.filters.client.id) {
			filter.client = vm.filters.client.id;
		}
		// estados
		if (vm.filters.states.selected && vm.filters.states.selected.length > 0) {
			filter.state = [];
			for ( var i in vm.filters.states.selected) {
				filter.state.push(vm.filters.states.selected[i].enumName);
			}
		}
		// id de la muestra
		if (vm.filters.idSample.selected && vm.filters.idSample.selected.length > 0) {
			filter.idSample = vm.filters.idSample.selected[0];
		}
		// usuario
		if (vm.filters.professionalSampling) {
			if (vm.filters.professionalSampling.selected) {
				filter.professionalSampling = vm.filters.professionalSampling.selected.id;
			} else if (vm.filters.professionalSampling.id) {
				filter.professionalSampling = vm.filters.professionalSampling.id;
			}
		}
		// sitio
		if (vm.filters.site.selected && vm.filters.site.selected.length > 0) {
			filter.site = vm.filters.site.selected[0].id;
		} else if (vm.filters.site.id) {
			filter.site = vm.filters.site.id;
		}
		// area
		if (vm.filters.area.selected && vm.filters.area.selected.length > 0) {
			filter.area = vm.filters.area.selected[0].id;
		} else if (vm.filters.area.id) {
			filter.area = vm.filters.area.id;
		}
		// plan de muestreo
		if (vm.filters.planSampling.selected && vm.filters.planSampling.selected.length > 0) {
			filter.planSampling = vm.filters.planSampling.selected[0].id;
		} else if (vm.filters.planSampling.id) {
			filter.planSampling = vm.filters.planSampling.id;
		}
		
		//filter.orderby = [ "takenDate desc" ];

		return filter;
	}

	// se debe definir en el scope pader
	// $scope.loadSamples = function() {
	//
	// var filter = getfilters();
	//
	// planSamplingService.searchSamplereceiveBasicInfo(filter).then(function(response)
	// {
	// $scope.loadInfo(response);
	// // $state.go('home.professionalSamplingTask', {
	// // reload : 'home.professionalSamplingTask.sample'
	// // });
	// }, function(response) {
	// });
	// }

	$scope.loadInfo = function(response) {
		var result = response.getData();
		vmParent.samples = result.results;

		vm.pagination.total = result.totalRegisters;

		vmParent.samples.forEach(function(s) {
			if (s.scheduleDate)
				s.scheduleDate = dateUtil.formatMomentDateTime(s.scheduleDate);
			if (s.takenDate)
				s.takenDate = dateUtil.formatMomentDateTime(s.takenDate);
			s.className = getConstantById(SAMPLE_STATE, s.state).className;
			s.tipClient = {};
		});
		
		if(vmParent.samples.length == 1){
			var s = vmParent.samples[0];
			$state.go(vmParent.urlSampleDetail, {
				idSample : s.id,
				idPlan: s.planSampling.id,
				idSampling: s.sampling.id
			});
		}else{
			$state.go(vmParent.urlSampleDetail, {
				idSample : null
			});
		}
	}

	init();
}